import { Action } from 'redux';
import { isDebuggerStatement } from 'typescript';
import { Group } from '../../clients/aasServerClient.generated';

export enum ActionTypeNames {
    FetchTableGroups = 'Groups/FetchTableGroups',
    FetchTableGroupsNoSearch= 'Groups/FetchTableGroupsNoSearch',
    StoreTableGroups = 'Groups/StoreTableGroups',

    FetchAllGroups = 'Groups/FetchAllGroups',
    FetchGroupsPerWorkspace = 'Groups/FetchGroupsPerWorkspaceGroups',
    StoreAllGroups = 'Groups/StoreAllGroups',
    StoreGroupsPerWorkspace = 'Groups/StoreGroupsPerWorkspaceGroups',

    ClearSingleGroup = 'Groups/ClearSingleGroup',
    FetchSingleGroup = 'Groups/FetchSingleGroup',
    NewSingleGroup = 'Groups/NewSingleGroup',
    CopySingleGroup = 'Groups/CopySingleGroup',
    StoreSingleGroup = 'Groups/StoreSingleGroup',
    CreateSingleGroup = 'Groups/CreateSingleGroup',
    SaveSingleGroup = 'Groups/SaveSingleGroup',
    SavedSingleGroup = 'Groups/SavedSingleGroup',

    DeleteGroups = 'Groups/DeleteGroups',
    AssignGroupsWorkspaces = 'Groups/AssignGroupsWorkspaces',
}

export type GroupsAction<T extends ActionTypeNames> = Action<T> & {
    groupIds: string[];
};


export type FetchTableGroupsAction = Action<ActionTypeNames.FetchTableGroups>;
export type FetchTableGroupsNoSearchAction = Action<ActionTypeNames.FetchTableGroupsNoSearch>;
export type StoreTableGroupsAction = Action<ActionTypeNames.StoreTableGroups> & {
    groups: Group[]
};

export type FetchAllGroupsAction = Action<ActionTypeNames.FetchAllGroups>;
export type StoreAllGroupsAction = Action<ActionTypeNames.StoreAllGroups> & {
    groups: Group[]
};

export type FetchGroupsPerWorkspaceAction = Action<ActionTypeNames.FetchGroupsPerWorkspace> & {
    ids: string[];
};
export type StoreGroupsPerWorkspaceAction = Action<ActionTypeNames.StoreGroupsPerWorkspace> & {
    groups: Group[]
};
export type FetchSingleGroupAction = Action<ActionTypeNames.FetchSingleGroup> & {
    id: string;
};
export type NewSingleGroupAction = Action<ActionTypeNames.NewSingleGroup>;
export type CopySingleGroupAction = Action<ActionTypeNames.CopySingleGroup> & {
    id: string;
};
export type StoreSingleGroupAction = Action<ActionTypeNames.StoreSingleGroup> & {
    group: Partial<Group>;
};
export type SaveSingleGroupAction = Action<ActionTypeNames.SaveSingleGroup> & {
    group: Partial<Group>;
    workspaces?: Array<{ id: string, value: boolean }>;
};

export type CreateSingleGroupAction = Action<ActionTypeNames.CreateSingleGroup> & {
    group: Partial<Group>;
    workspaces?: Array<{ id: string, value: boolean }>;
};

export type ClearSingleGroupAction = Action<ActionTypeNames.ClearSingleGroup>;
export type SavedSingleGroupAction = Action<ActionTypeNames.SavedSingleGroup>;

export type DeleteGroupsAction = GroupsAction<ActionTypeNames.DeleteGroups>;
export type AssignGroupsWorkspacesAction = GroupsAction<ActionTypeNames.AssignGroupsWorkspaces> & {
    workspaceIds: string[];
};
